export default __webpack_public_path__ + "static/media/print_kouji_3.1a54808d.svg";